import type {MCFetcher} from '@github-ui/ahp-relay/mission-control/mission-control-environment-client'
import type {AuthToken} from '@github-ui/copilot-auth-token/auth-token'
import {fetchCAPI} from '@github-ui/copilot-shared-ui/capi/fetch-capi'

export function createMCFetcher(copilotApiUrl?: string, authToken?: AuthToken): MCFetcher {
  return (path, options) =>
    fetchCAPI({
      path,
      copilotApiUrl,
      authToken,
      additionalHeaders: {Accept: 'application/json'},
      signal: options?.signal,
    })
}

/** Mission Control fetcher backed by the agent-sessions CAPI client. */
export const mcFetcher = createMCFetcher()
